import { apiRequest, authRequest } from '../config/api';

// User API endpoints
export const userAPI = {
  // Auth endpoints
  register: (userData) => apiRequest('/User/register', {
    method: 'POST',
    body: JSON.stringify(userData),
  }),
  
  login: (credentials) => apiRequest('/User/login', {
    method: 'POST',
    body: JSON.stringify(credentials),
  }),
  
  changePassword: (passwordData) => authRequest('/User/create_new_password', {
    method: 'POST',
    body: JSON.stringify(passwordData),
  }),
  
  updateUser: (userData) => authRequest('/User/update', {
    method: 'POST',
    body: JSON.stringify(userData),
  }),
  
  deleteUser: (userId) => authRequest(`/User/delete_account/${userId}`, {
    method: 'POST',
  }),
  
  getAllUsers: () => authRequest('/User/get_users', {
    method: 'GET',
  }),
}; 